import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosCategoryFormPage } from './cronos-category-form';

@NgModule({
  declarations: [
    CronosCategoryFormPage,
  ],
  imports: [
    IonicPageModule.forChild(CronosCategoryFormPage),
  ],
})
export class CronosCategoryFormPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-category-form/cronos-category-form.module.ts